const setNearbyName = (type) => {
  switch (type) {
    case 'Adventurous':
      return 'Adventures Activities'

    case 'Romantic':
      return 'Romantic Places'

    case 'Religious':
      return 'Religious Shrines'

    case 'Heritage':
      return 'Heritage Places'

    case 'Relaxing':
      return 'Relaxing Retreats'

    case 'Beach':
      return 'Beaches'

    case 'Hills':
      return 'Hilly Regions'

    case 'Forest':
      return 'Nearby Forests'

    case 'Desert':
      return 'Desert Experience'
  }
}

export default setNearbyName
